export default __webpack_public_path__ + "static/media/Copyright.c3e7207e.txt";